import { render, staticRenderFns } from "./BaseBlock.vue?vue&type=template&id=3e682e30&"
import script from "./BaseBlock.vue?vue&type=script&lang=js&"
export * from "./BaseBlock.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports